import styled from "styled-components";

export const StyledForm = styled.form`
  height: 100%;
  width: 450px;
  display: flex;
  flex-direction: column;
`;

export const StyledModalHeader = styled.div`
  margin: auto;
`;

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  padding: 2rem 0;
  height: 100%;
  width: 100%;
  gap: 1rem;
`;

export const StyledFormRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const StyledModalFooter = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
`;

export const StyledButtonArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  column-gap: 1rem;
`;
